<div class="card card-primary card-outline style">
  <div class="card-body box-profile">
    
   
 <p class="style1">
      <b>{{number}}</b>
    </p>
    <div class="table-responsive">

      <div *ngFor="let c of output">
      <table class="table style">
      <tbody>
      <tr>
      <th style="width:30%">Date And Time:</th>
      <td>{{DateAndTime}}</td>
      </tr>

      <tr>
      <th>Total Sales Value:</th>
      <td>{{Total_sales}}</td>
      </tr>

      <tr>
      <th>Total Amount:</th>
      <td>{{c.total_amount}}</td>
      </tr>

      <tr>
      <th>Company Name:</th>
      <td>{{c.company_name}}</td>
      </tr>

      <tr>
      <th>Responsible Employee Code:</th>
      <td>{{c.responsible_employee_code}}</td>
      </tr>

      <tr>
      <th>Responsible Employee Id:</th>
      <td>{{c.responsible_employee_id}}</td>
      </tr>

      <tr>
      <th>Transaction Type:</th>
      <td>{{c.transaction_type}}</td>
      </tr>

      <tr>
      <th>Status:</th>
      <td>{{c.status}}</td>
      </tr>

     
      <tr>
      <th>Contract:</th>
      <td>{{c.contract}}</td>
      </tr>
      </tbody></table>

      <p class="style2">
        <b>Inventory and Services:</b>
         <div class="card">
          <div class="space" *ngFor="let d of c.inventory_service_list">
         
            <strong class="distance1">Item Name:</strong>{{d.item_name}}<br>
            <strong class="distance2">Quantity:</strong>{{d.quantity}}<br>
            <strong class="distance3">Unit Price:</strong>{{d.unit_price}}
            <hr>

        

<!--------------------------------
<h1 *ngIf="output==''">No invoice data</h1>
<form class="center">
<h1>Sales Details</h1>
    <div class="settings" *ngFor="let c of output">

      <label>Number:</label><label>{{c.invoice_number}}</label>
      <label>Date and Time:</label><label>{{DateAndTime}}</label>
      <label>Total Sales Value:</label><label>{{Total_sales}}</label>
      <label>Total Amount:</label><label>{{c.total_amount}}</label>

      <label>Company Name:</label><label>{{c.company_name}}</label>
      <label>Responsible Employee code:</label><label>{{c.responsible_employee_code}}</label>
      <label>Transaction Type:</label><label>{{c.transaction_type}}</label>
      <label>Status:</label><label>{{c.status}}</label>
      <label>Contract:</label><label>{{c.contract}}</label>

      <label class="colour">Inventory and Services:</label><br>
    
      <div class="settings" *ngFor="let d of c.inventory_service_list">
        <label>Item name:</label><label>{{d.item_name}}</label>
        <label>Quantity:</label><label>{{d.quantity}}</label>
        <label>Unit price:</label><label>{{d.unit_price}}</label>   
     

    </div>
  </div>
  
</form>

----------------------------------->